import { Component, OnInit, Input, Output } from '@angular/core';
import { FormItem } from '../form/FormItem';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'vias-img',
  templateUrl: './img.component.html',
  styleUrls: ['./img.component.scss']
})
export class ImgComponent implements OnInit {
  @Input() item: FormItem;
  @Input() form: FormGroup;
  constructor() {}
  ngOnInit(): void {}
}
